import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export type State = {
  scannedCode: string | null
}

const slice = createSlice({
  name: 'barcodeScanner',
  initialState: {
    scannedCode: null,
  } as State,
  reducers: {
    setScannedCode: (state, action: PayloadAction<string>) => {
      state.scannedCode = action.payload
    },
  },
})

export const { setScannedCode } = slice.actions

export default slice.reducer
